import React from "react";
import { Stack, styled, Typography } from "@mui/material";

const StyledContainer = styled(Stack)`
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding-top: 2em;
`;

const SearchNoResults = () => {
  return (
    <StyledContainer>
      <Typography
        variant="h4"
        color="error"
      >
        No Results
      </Typography>
    </StyledContainer>
  );
};

export default SearchNoResults;